export default "__VITE_ASSET__zc5QpiiA__"